import {createContext} from 'react'
import {InvoiceContext} from './_context'

export const InvoiceProvider = InvoiceContext.Provider
